/* generated by pull.js */
const manifest = {
  editorOnly: true,
  name: 'Astra Copilot',
  description: 'A Scratch Agent for AstraEditor',
  tags: ['new', 'recommended'],
  credits: [
    {
      name: 'Cyberexplorer',
      link: 'https://github.com/LanwyWriteXU'
    }
  ],

  userscripts: [
    {
      url: 'userscript.js'
    }
  ],
  userstyles: [
    {
      url: 'agent.css'
    }
  ],
  dynamicDisable: true
};
export default manifest;
